<template>
    <div id="Section-04" class="section-04 wsl-flex-center-ng">
        <div class="container">
            <div class="wsl-show-sm wsl-show-xs"
                 :style="{backgroundImage: `url(${s04Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="cb-bg-blue block-header wsl-p-y-10">
                    <div class="wsl-flex-middle-ng">
                        <div class="Oswald-Regular wsl-bg-white cb-cyan t24 wsl-flex-center-middle-ng wsl-p-x-6">04</div>
                        <div class="Oswald-Regular cb-cyan t24 wsl-m-l-15">Отели</div>
                    </div>
                </div>

                <div class="wsl-p-y-40 padding-sm-xs">
                    <div class="wsl-m-b-30" style="line-height: 1.2">
                        <span class="Oswald-Light cb-cyan t48">Легкий поиск и бронирование </span>
                        <span class="Oswald-Light cb-blue t48">отелей, гостиниц и хостелов по выгодным тарифам</span>
                    </div>

                    <div class="Oswald-Light t24 wsl-m-y-8">
                        Доступно более <span class="cb-blue">1 000 000</span> отелей по всему миру от более чем <span
                            class="cb-blue">75</span> поставщиков
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-8">
                        Достоверная база отзывов по объектам размещения
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-8">
                        Моментальное подтверждения бронирования с высокой комиссией
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-8">
                        Возможность оплатить бронь сразу или выбрать вариант с оплатой на месте размещения
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-8">
                        Поддержка клиентов <span class="cb-blue">24/7</span> в мультиязычном формате
                    </div>
                    <div class="wsl-m-t-50 wsl-m-b-20 wsl-text-center">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>

            </div>

            <div class="wsl-relative wsl-show-md"
                 :style="{backgroundImage: `url(${s04Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s04Bg2}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: bottom right;
                    top: 0; right: 6.3%; width: 27.06%; height: 12.3%; z-index: 1;">
                    <div class="wsl-w-100 wsl-h-100">
                        <div class="wsl-w-100 wsl-h-100 wsl-flex-middle-ng" style="padding-left: 12.15%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6 wsl-m-t-15">
                                04
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15 wsl-m-t-15">Отели</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs" style="
                    background-color: #0056cd;
                    opacity: 0.2;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: bottom right;
                    top: 5.5%; right: 16.75%; width: 20.7%; height: 12.29%;">
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${blueBox}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    top: 0; left: 0; width: 33.34%; height: 5%;">
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${blueBox}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    bottom: 0; right: 0; width: 33.34%; height: 12.6%;">
                </div>

                <div class="wsl-p-t-100 wsl-p-b-50" style="padding-left: 10%;">
                    <div class="wsl-m-b-30" style="line-height: 1.2">
                        <span class="Oswald-Light cb-cyan t48">Легкий поиск и бронирование </span><br>
                        <span class="Oswald-Light cb-blue t48">отелей, гостиниц и хостелов по выгодным тарифам</span>
                    </div>

                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Доступно более <span class="cb-blue">1 000 000</span> отелей по всему миру от более чем <span
                            class="cb-blue">75</span> поставщиков
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Достоверная база отзывов по объектам размещения
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Моментальное подтверждения бронирования с высокой комиссией
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Возможность оплатить бронь сразу или выбрать вариант с оплатой на месте размещения
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        <div class="wsl-inline-block wsl-text-center">
                            Поддержка клиентов <span class="cb-blue">24/7</span> в мультиязычном формате<br>
                            <a class="cb-btn-blue wsl-inline-block z-depth-3 wsl-m-t-60" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                        </div>

                    </div>

                </div>

            </div>

            <div class="wsl-w-100 wsl-h-100 wsl-relative wsl-hide-md wsl-hide-sm wsl-hide-xs">
                <img alt="" class="wsl-w-100 wsl-h-100"
                     src="../assets/img/s04-bg1.jpg">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s04Bg2}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: bottom right;
                    top: 0; right: 6.3%; width: 27.06%; height: 12.3%; z-index: 1;">
                    <div class="wsl-w-100 wsl-h-100">
                        <div class="wsl-w-100 wsl-h-100 wsl-flex-middle-ng" style="padding-left: 12.15%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6 wsl-m-t-15">
                                04
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15 wsl-m-t-15">Отели</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs" style="
                    background-color: #0056cd;
                    opacity: 0.2;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: bottom right;
                    top: 5.5%; right: 16.75%; width: 20.7%; height: 12.29%;">
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${blueBox}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    top: 0; left: 0; width: 33.34%; height: 5%;">
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${blueBox}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    bottom: 0; right: 0; width: 33.34%; height: 12.6%;">
                </div>

                <div class="wsl-abs" style="top: 19%; padding-left: 16.54%; padding-right: 15%;">
                    <div class="wsl-m-b-30" style="line-height: 1.2">
                        <span class="Oswald-Light cb-cyan t48">Легкий поиск и бронирование </span><br>
                        <span class="Oswald-Light cb-blue t48">отелей, гостиниц и хостелов по выгодным тарифам</span>
                    </div>

                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Доступно более <span class="cb-blue">1 000 000</span> отелей по всему миру от более чем <span
                            class="cb-blue">75</span> поставщиков
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Достоверная база отзывов по объектам размещения
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Моментальное подтверждения бронирования с высокой комиссией
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        Возможность оплатить бронь сразу или выбрать вариант с оплатой на месте размещения
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-25 cb-grey">
                        <div class="wsl-inline-block wsl-text-center">
                            Поддержка клиентов <span class="cb-blue">24/7</span> в мультиязычном формате<br>
                            <a class="cb-btn-blue wsl-inline-block z-depth-3 wsl-m-t-80" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Section-04',
  props: {
    blueBox: String,
    s04Bg1: String,
    s04Bg2: String,
    s04Bg3: String
  }
}
</script>

<style scoped>

</style>
